/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateTagsControllerFindAllQueryResponse, TemplateTagsControllerFindAllQueryParams, TemplateTagsControllerFindAll401, TemplateTagsControllerFindAll403 } from "../../models/checklistsController/TemplateTagsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateTagsControllerFindAll } from "../../clients/checklistsService/templateTagsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateTagsControllerFindAllQueryKey = (params: TemplateTagsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-template-tags'
}, ...(params ? [params] : [])] as const;
export type TemplateTagsControllerFindAllQueryKey = ReturnType<typeof templateTagsControllerFindAllQueryKey>;
export function templateTagsControllerFindAllQueryOptions(params?: TemplateTagsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateTagsControllerFindAllQueryKey(params);
  return queryOptions<TemplateTagsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateTagsControllerFindAll401 | TemplateTagsControllerFindAll403>, TemplateTagsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateTagsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List all template tags
 * {@link /api/v1/checklist-template-tags}
 */
export function useTemplateTagsControllerFindAll<TData = TemplateTagsControllerFindAllQueryResponse, TQueryData = TemplateTagsControllerFindAllQueryResponse, TQueryKey extends QueryKey = TemplateTagsControllerFindAllQueryKey>(params?: TemplateTagsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateTagsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateTagsControllerFindAll401 | TemplateTagsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateTagsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...templateTagsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateTagsControllerFindAll401 | TemplateTagsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}